export type ChampionIconKind = 'crown' | 'trophy' | 'star' | 'none' | 'custom'
export type BracketAppearance = {
  icon: ChampionIconKind
  iconColor: string
  iconSize: number
  customIcon: string | null
  textColor: string | null
  connectorColor: string | null
  cardColor: string | null
  cardOpacity: number
}

export const APPEARANCE_STORAGE_KEY = 'snapbracket:bracket-appearance'
export const DEFAULT_APPEARANCE: BracketAppearance = {
  icon: 'crown',
  iconColor: '#f59e0b',
  iconSize: 48,
  customIcon: null,
  textColor: null,
  connectorColor: null,
  cardColor: null,
  cardOpacity: 1,
}

const color = (value: unknown, fallback: string | null) =>
  typeof value === 'string' && /^#[0-9a-f]{6}$/i.test(value) ? value : fallback
const bounded = (value: unknown, fallback: number, min: number, max: number) =>
  typeof value === 'number' && Number.isFinite(value)
    ? Math.min(max, Math.max(min, value))
    : fallback

export function normalizeAppearance(value: unknown): BracketAppearance {
  const raw = (
    value && typeof value === 'object' ? value : {}
  ) as Partial<BracketAppearance>
  const customIcon =
    typeof raw.customIcon === 'string' &&
    raw.customIcon.length < 1_500_000 &&
    /^data:image\/(png|webp|jpeg);base64,[a-z0-9+/=]+$/i.test(raw.customIcon)
      ? raw.customIcon
      : null
  const icon = ['crown', 'trophy', 'star', 'none', 'custom'].includes(
    raw.icon ?? '',
  )
    ? raw.icon!
    : DEFAULT_APPEARANCE.icon
  return {
    icon: icon === 'custom' && !customIcon ? 'crown' : icon,
    iconColor: color(raw.iconColor, DEFAULT_APPEARANCE.iconColor)!,
    iconSize: bounded(raw.iconSize, 48, 24, 64),
    customIcon,
    textColor: color(raw.textColor, null),
    connectorColor: color(raw.connectorColor, null),
    cardColor: color(raw.cardColor, null),
    cardOpacity: bounded(raw.cardOpacity, 1, 0, 1),
  }
}

export function cardBackground({ cardColor, cardOpacity }: BracketAppearance) {
  if (!cardColor) return `hsl(var(--background) / ${cardOpacity})`
  const channels = [1, 3, 5].map((start) =>
    parseInt(cardColor.slice(start, start + 2), 16),
  )
  return `rgba(${channels.join(', ')}, ${cardOpacity})`
}
